// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Added the comments
// MODIFIED DATE : 27-09-2025

import CloseLoanAdvanceTypes from './close-loan-advance.types';

/******* GET ALL LOAN ADVANCE COLLECTED MEMBERS LIST ******* */
export const getAllLoanAdvanceCollectedMembersListStart = (payload: any) => ({
	type: CloseLoanAdvanceTypes.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_START,
	payload,
});

export const getAllLoanAdvanceCollectedMembersListSuccess = (payload: any) => ({
	type: CloseLoanAdvanceTypes.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_SUCCESS,
	payload,
});

export const getAllLoanAdvanceCollectedMembersListFailure = (payload: unknown) => ({
	type: CloseLoanAdvanceTypes.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_FAILURE,
	payload,
});

export const getAllLoanAdvanceCollectedMembersListResponseResetStart = () => ({
	type: CloseLoanAdvanceTypes.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_RESPONSE_RESET_START,
});

export const getAllLoanAdvanceCollectedMembersListResponseChanged = () => ({
	type: CloseLoanAdvanceTypes.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_RESPONSE_CHANGED,
});
/******* GET ALL LOAN ADVANCE COLLECTED MEMBERS LIST ******* */

/******* FETCH PARTICULAR ACCOUNT NAME INFO ******* */
export const fetchParticularAccountNameInfoStart = (payload: any) => ({
	type: CloseLoanAdvanceTypes.FETCH_PARTICULAR_ACCOUNT_NAME_INFO_START,
	payload,
});

export const fetchParticularAccountNameInfoSuccess = (payload: any) => ({
	type: CloseLoanAdvanceTypes.FETCH_PARTICULAR_ACCOUNT_NAME_INFO_SUCCESS,
	payload,
});

export const fetchParticularAccountNameInfoFailure = (payload: unknown) => ({
	type: CloseLoanAdvanceTypes.GET_ALL_LOAN_ADVANCE_COLLECTED_MEMBERS_LIST_FAILURE,
	payload,
});

export const fetchParticularAccountNameInfoResponseResetStart = () => ({
	type: CloseLoanAdvanceTypes.FETCH_PARTICULAR_ACCOUNT_NAME_INFO_RESPONSE_RESET_START,
});

export const fetchParticularAccountNameInfoStartResponseChanged = () => ({
	type: CloseLoanAdvanceTypes.FETCH_PARTICULAR_ACCOUNT_NAME_INFO_RESPONSE_CHANGED,
});
/******* FETCH PARTICULAR ACCOUNT NAME INFO ******* */

/******** GET ACCOUNT BASED ON TYPE ******** */
export const getAccountsBasedonTypeStart = (payload: any) => ({
	type: CloseLoanAdvanceTypes.GET_ACCOUNTS_BASEDON_TYPE_START,
	payload,
});

export const getAccountsBasedonTypeSuccess = (payload: any) => ({
	type: CloseLoanAdvanceTypes.GET_ACCOUNTS_BASEDON_TYPE_SUCCESS,
	payload,
});

export const getAccountsBasedonTypeFailure = (payload: unknown) => ({
	type: CloseLoanAdvanceTypes.GET_ACCOUNTS_BASEDON_TYPE_FAILURE,
	payload,
});

export const getAccountsBasedonTypeResponseResetStart = () => ({
	type: CloseLoanAdvanceTypes.GET_ACCOUNTS_BASEDON_TYPE_RESPONSE_RESET_START,
});

export const getAccountsBasedonTypeResponseChanged = () => ({
	type: CloseLoanAdvanceTypes.GET_ACCOUNTS_BASEDON_TYPE_RESPONSE_CHANGED,
});
/******** GET ACCOUNT BASED ON TYPE ******** */

/****** UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT ****** */
export const updateCloseLoanAdvanceWithRepaymentStart = (payload: any) => ({
	type: CloseLoanAdvanceTypes.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_START,
	payload,
});

export const updateCloseLoanAdvanceWithRepaymentSuccess = (payload: any) => ({
	type: CloseLoanAdvanceTypes.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_SUCCESS,
	payload,
});

export const updateCloseLoanAdvanceWithRepaymentFailure = (payload: unknown) => ({
	type: CloseLoanAdvanceTypes.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_FAILURE,
	payload,
});

export const updateCloseLoanAdvanceWithRepaymentResponseResetStart = () => ({
	type: CloseLoanAdvanceTypes.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_RESET_START,
});

export const updateCloseLoanAdvanceWithRepaymentResponseChanged = () => ({
	type: CloseLoanAdvanceTypes.UPDATE_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_CHANGED,
});
/****** UPDATE CLOSE LOAN ADVANCE WITH REPAYMENT ****** */

/****** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT ****** */
export const revertCloseLoanAdvanceWithRepaymentStart = (payload: any) => ({
	type: CloseLoanAdvanceTypes.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_START,
	payload,
});

export const revertCloseLoanAdvanceWithRepaymentSuccess = (payload: any) => ({
	type: CloseLoanAdvanceTypes.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_SUCCESS,
	payload,
});

export const revertCloseLoanAdvanceWithRepaymentFailure = (payload: unknown) => ({
	type: CloseLoanAdvanceTypes.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_FAILURE,
	payload,
});

export const revertCloseLoanAdvanceWithRepaymentResponseResetStart = () => ({
	type: CloseLoanAdvanceTypes.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_RESET_START,
});

export const revertCloseLoanAdvanceWithRepaymentResponseChanged = () => ({
	type: CloseLoanAdvanceTypes.REVERT_CLOSE_LOAN_ADVANCE_WITH_REPAYMENT_RESPONSE_CHANGED,
});
/****** REVERT CLOSE LOAN ADVANCE WITH REPAYMENT ****** */
